import React from "react";
import { PdfIcon, VideoLibrary } from "src/assets/icon";
import styled from "styled-components";

export const PdfContainer = ({ file, urlKey, textKey }) => {
  if (!file || !file[urlKey]) {
    return (
      <PdfContainerStyled>
        <span>No Information Found</span>
      </PdfContainerStyled>
    );
  }

  const url = file[urlKey];
  const text = file[textKey];
  const extension = file.extension;

  const IconComponent = extension === "VID" ? VideoLibrary : PdfIcon;
  return (
    <PdfContainerStyled href={url} target="_blank">
      <IconComponent className="icon" />
      <IconText className="icon-text">{text}</IconText>
    </PdfContainerStyled>
  );
};

const PdfContainerStyled = styled.a`
  display: flex;
  flex-direction: row;
  margin: 10px 0;
  text-decoration: none;
  align-items: center;
  width: 100%;
`;

const IconText = styled.p`
  flex-grow: 1;
  max-width: 100%;
`;
